import { render, staticRenderFns } from "./ArticleHotBeautyCard.vue?vue&type=template&id=60c55f8c&"
import script from "./ArticleHotBeautyCard.vue?vue&type=script&lang=js&"
export * from "./ArticleHotBeautyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports